export default __webpack_public_path__ + "locales/bg/DeleteSelfProfileDialog.json?hash=3439a4e1b6f1b752c62a6e7daa1126bf";